import React, { useState } from 'react';
import { BookOpen, Clock, Globe, ChevronDown, ChevronUp, PlayCircle } from 'lucide-react';
import { BowTieHistory } from './BowTieHistory';
import { TyingGuide } from './TyingGuide';
import { VideoTutorials } from './VideoTutorials';

const SECTIONS = [
  { id: 'history', title: 'The History of the Bow Tie', icon: Globe, Content: BowTieHistory },
  { id: 'tying', title: 'How to Tie a Bow Tie', icon: Clock, Content: TyingGuide },
  { id: 'videos', title: 'Video Tutorials', icon: PlayCircle, Content: VideoTutorials },
];

const Resources = () => {
  const [openSection, setOpenSection] = useState('history');

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <section id="resources" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#E6D7B3] rounded-full mb-4">
            <BookOpen className="h-8 w-8 text-[#001B2A]" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-[#001B2A] mb-4">
            Bow Tie Resources
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Everything you need to know about bow ties - from their rich history to tying techniques
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-6">
          {SECTIONS.map(({ id, title, icon: Icon, Content }) => (
            <div key={id} className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
              <button
                onClick={() => toggleSection(id)}
                className="w-full flex items-center justify-between p-6 sm:p-8 hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-4">
                  <Icon className="h-6 w-6 text-[#7B1E2B]" />
                  <h3 className="text-xl sm:text-2xl font-serif font-bold text-[#001B2A] text-left">
                    {title}
                  </h3>
                </div>
                {openSection === id ? (
                  <ChevronUp className="h-6 w-6 text-gray-400" />
                ) : (
                  <ChevronDown className="h-6 w-6 text-gray-400" />
                )}
              </button>

              {openSection === id && (
                <div className="px-6 sm:px-8 pb-8">
                  <Content />
                </div>
              )}
            </div>
          ))}

          {/* CTA */}
          <div className="bg-gradient-to-br from-[#001B2A] to-[#7B1E2B] rounded-lg p-8 sm:p-12 text-white">
            <h3 className="text-2xl sm:text-3xl font-serif font-bold mb-6 text-center">
              Need Help Choosing the Perfect Bow Tie?
            </h3>
            <p className="text-lg mb-8 text-center max-w-2xl mx-auto">
              With decades of experience, Johnnie can guide you to the perfect bow tie for any occasion - from weddings and galas to business meetings and casual events.
            </p>
            <div className="text-center">
              <button
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                className="inline-block bg-white text-[#001B2A] px-8 py-4 rounded-md font-semibold hover:bg-[#E6D7B3] transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                CONTACT THE BOW TIE GUY
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resources;
